import { useDeepCompareEffect, useSetState } from 'ahooks'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'

import { SELECT_MODE } from '@/constants'
import useInited from '@/hooks/useInited'
import { dealCellTitle, findValuesByKeys } from '@/utils'

import { HPopup } from '../../HYBVant/'
import HCell from '../../HYBVant/HCell'
import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

import { getemployeeApi } from './PersonnelSelectPopup/services'
import SelectView from './PersonnelSelectView'

import './index.less'

export const PersonnelSelectView = SelectView

interface PersonnelSelectProps {
  value?: any
  onChange?: (value: any) => void
  type?: string
  [key: string]: any
}

function PersonnelSelect(props: PersonnelSelectProps) {
  const { onChange, onAfterChange, ...restProps } = props
  const [{ checkedList }, setState] = useSetState<any>({
    checkedList: []
  })
  const mode = findValuesByKeys(props, ['mode'])?.mode || SELECT_MODE.MULTIPLE

  const { open, onOpen, onOk, onCancel } = usePopup({
    afterOk: (data?: any) => {
      setState({ checkedList: data })
      onChange?.(data)
      onAfterChange?.(data)
      return Promise.resolve()
    }
  })

  // 处理 value
  const value: any = useMemo(() => {
    const tempValue = props?.value
    if (Array.isArray(tempValue)) {
      return tempValue?.map((x: any) => (typeof x === 'string' ? { id: x } : x))
    }
    if (tempValue && typeof tempValue === 'string') {
      return [{ id: tempValue }]
    }
    return tempValue ? [tempValue] : []
  }, [props?.value, open])

  // 初始化默认选中值
  const [, initSuccess] = useInited(1, 0, () => {
    const id_list = value?.map((x: any) => x?.id)
    getemployeeApi({
      employee_ids: id_list,
      with_no_auth: true,
      paged: false
    }).then(({ success, data }: any) => {
      if (success) {
        const node = value?.map((x: any) => {
          const currentItem = data?.find((item: any) => item?.id === x?.id) || {}
          return { ...x, ...currentItem }
        })
        setState({ checkedList: node })
      }
    })
  })

  useDeepCompareEffect(() => {
    if (value?.[0]?.name) {
      setState({ checkedList: value as any })
    } else if (value?.length > 0) {
      initSuccess()
    }
  }, [value])

  console.log('open.value', value, onChange)

  const cellTitle = dealCellTitle({
    value: checkedList,
    suffix: '人'
  })
  const bool: boolean = !props?.disabled && !props?.readed

  return (
    <>
      <HCell
        value={cellTitle}
        readed={props?.readed}
        onClick={() => bool && onOpen()}
        disabled={props?.disabled}
      />
      {open && (
        <HPopup
          title='请选择'
          visible={open}
          size='lg'
          className='personnel-select-popup'
          closeOnMaskClick
          hasOk={false}
          onClose={onCancel}
        >
          <SelectView
            {...restProps}
            mode={mode}
            value={checkedList}
            visible={open}
            onConfirm={onOk}
            onCancel={onCancel}
          />
        </HPopup>
      )}
    </>
  )
}

/**
 * 前置化转换 - 用于回显
 * @param value
 * @param config
 * @returns newValue
 */
PersonnelSelect.convertValue = async (value: any, config?: any, values?: any) => {
  if (values && Array.isArray(config?.names) && config?.names?.length === 2) {
    // console.log('[config?.names[0]]:', values, [config?.names[0]], values[config?.names[0]])
    // 单选
    if (config?.mode === 'single' && values?.[config?.names[0]] && values?.[config?.names[1]]) {
      return {
        [config?.names[0]]: [
          {
            id: values?.[config?.names[0]],
            name: values?.[config?.names[1]]
          }
        ]
      }
    }
  }
  if (config?.name) {
    return values?.[config.name]
  }
  if (value?.length === 1 && value?.[0]?.id && !value?.[0]?.name && config?.mode === 'single') {
    const { success, data } = await getemployeeApi({
      employee_ids: [value?.[0]?.id],
      paged: false,
      with_no_auth: true
    })
    if (success && data?.[0]?.name) {
      return [
        {
          id: data[0].id,
          name: data[0].name
        }
      ]
    }
  }
  return value
}
/**
 * 提交时转换
 * @param value
 * @param config
 * @returns newValue
 */
PersonnelSelect.transform = (value: any, config?: any) => {
  if (Array.isArray(value) && Array.isArray(config?.names) && config?.names?.length === 2) {
    // 单选
    if (config?.mode === 'single') {
      return {
        [config?.names[0]]: value?.[0]?.id,
        [config?.names[1]]: value?.[0]?.name
      }
    }
    return {
      [config?.names[0]]: value.map((item: any) => item?.id),
      [config?.names[1]]: value.map((item: any) => item?.name)
    }
  }
  // 单选
  if (Array.isArray(value) && config?.mode === 'single') {
    return value?.[0]?.id
  }
  // 多选
  if (Array.isArray(value)) {
    return value.map((item: any) => item?.id)
  }
  return value
}

export default observer(PersonnelSelect)
